import { gql } from 'graphql-request'

export namespace FollowUpStatusQueries {
  export namespace GET {
    export type Response = { followUpTaskStatuses: FollowUpTaskStatus[] | null }
  }
  // Explicit string — do not use getFollowUpTaskStatuses.name; minification mangles it
  export const QUERY_KEY = 'getFollowUpTaskStatuses'
  export function getFollowUpTaskStatuses() {
    return gql`
      query getFollowUpTaskStatuses($filter: FollowUpTaskStatusFilter = { active: true }) {
        followUpTaskStatuses(filter: $filter) {
          id
          description
        }
      }
    `
  }
}

export interface FollowUpTaskStatus {
  description: string
  id: number
}
